import OverlayManager from "../OverlayManager.js";
import Overlay from "./Overlay.js";


class FooterMenu {
    /**
     * @author Corentin (ccharton) Charton
     * @description Construct the FooterMenu module
     */
    constructor() {
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Teleport the player to the online Pong game area
     * @returns {Promise<void>}
     */
   async onlinePong() {
       if (OverlayManager.game) {
           OverlayManager.game.teleportTo('macPong');
           Overlay.closeOverlay()
       }
   }

    /**
     * @author Corentin (ccharton) Charton
     * @description Teleport the player to the local Pong game area
     * @returns {Promise<void>}
     */
    async localPong() {
        if (OverlayManager.game) {
            OverlayManager.game.teleportTo('atariPong');
            Overlay.closeOverlay()

        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Teleport the player to the Pacman game area
     * @returns {Promise<void>}
     */
    async pacman() {
        if (OverlayManager.game) {
            OverlayManager.game.teleportTo('pacman');
            Overlay.closeOverlay()
        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Teleport the player to the Tetris game area
     * @returns {Promise<void>}
     */
    async tetris() {
        if (OverlayManager.game) {
            OverlayManager.game.teleportTo('tetris');
            Overlay.closeOverlay()
        }
    }
}

export default new FooterMenu()